module.exports = __webpack_public_path__ + "static/2021923-144157-429db654f31bfe6b66e92c1311fa425f.jpeg";